// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services__grid--magic {
  --magic-white: hsl(0, 0%, 100%);
  --magic-border-color: #2f293a;
  --magic-background-dark: transparent;
  --magic-purple-glow: rgba(154, 233, 253, 0.2);
  position: relative;
  user-select: none;
}

.services__grid--magic .magic-bento-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 0;
  border-radius: 16px;
  border: 1px solid transparent;
  background: transparent;
  font-weight: 300;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  --glow-x: 50%;
  --glow-y: 50%;
  --glow-intensity: 0;
  --glow-radius: 200px;
}

.services__grid--magic .magic-bento-card:hover {
  transform: translateY(-2px);
}

.services__grid--magic .magic-bento-card__header,
.services__grid--magic .magic-bento-card__content {
  display: flex;
  position: relative;
  color: var(--magic-white);
}

.services__grid--magic .magic-bento-card__header {
  gap: 0.75em;
  justify-content: space-between;
}

.services__grid--magic .magic-bento-card__content {
  flex-direction: column;
}

.services__grid--magic .magic-bento-card__label {
  font-size: 16px;
}

.services__grid--magic .magic-bento-card__title,
.services__grid--magic .magic-bento-card__description {
  --clamp-title: 1;
  --clamp-desc: 2;
}

.services__grid--magic .magic-bento-card__title {
  font-weight: 400;
  font-size: 16px;
  margin: 0 0 0.25em;
}

.services__grid--magic .magic-bento-card__description {
  font-size: 12px;
  line-height: 1.2;
  opacity: 0.9;
}

.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__title,
.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__title {
  -webkit-line-clamp: var(--clamp-title);
  line-clamp: var(--clamp-title);
}

.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__description {
  -webkit-line-clamp: var(--clamp-desc);
  line-clamp: var(--clamp-desc);
}

.services__grid--magic .magic-bento-card__border-glow {
  content: "";
  position: absolute;
  inset: 0;
  padding: 6px;
  background: radial-gradient(
    var(--glow-radius) circle at var(--glow-x) var(--glow-y),
    rgba(var(--magic-glow-rgb), calc(var(--glow-intensity) * 0.8)) 0%,
    rgba(var(--magic-glow-rgb), calc(var(--glow-intensity) * 0.4)) 30%,
    transparent 60%
  );
  border-radius: inherit;
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  z-index: 3;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.services__grid--magic .magic-bento-card--border-glow:hover .magic-bento-card__border-glow {
  opacity: 1;
}

.services__grid--magic .magic-bento-card--border-glow:hover {
  box-shadow:
    0 4px 20px rgba(46, 24, 78, 0.4),
    0 0 30px var(--magic-purple-glow);
}

.services__grid--magic .particle-container {
  position: relative;
  overflow: hidden;
}

.services__grid--magic .particle::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: rgba(var(--magic-glow-rgb), 0.2);
  border-radius: 50%;
  z-index: -1;
}

.services__grid--magic .particle-container:hover {
  box-shadow:
    0 4px 20px rgba(46, 24, 78, 0.2),
    0 0 30px var(--magic-purple-glow);
}

.global-spotlight {
  mix-blend-mode: screen;
  will-change: transform, opacity;
  z-index: 200 !important;
  pointer-events: none;
}

.services__magic-hit {
  position: absolute;
  inset: 0;
  z-index: 12;
}

.services__grid--magic .services__card-inner {
  position: relative;
  z-index: 4;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./components/MagicBento/MagicBento.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,qDAAqD;;EAErD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ;;;;;GAKC;EACD,sBAAsB;EACtB;;6BAE2B;EAC3B,2BAA2B;EAC3B;;6BAE2B;EAC3B,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;EACV,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB","sourcesContent":[".services__grid--magic {\n  --magic-white: hsl(0, 0%, 100%);\n  --magic-border-color: #2f293a;\n  --magic-background-dark: transparent;\n  --magic-purple-glow: rgba(154, 233, 253, 0.2);\n  position: relative;\n  user-select: none;\n}\n\n.services__grid--magic .magic-bento-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  background: transparent;\n  font-weight: 300;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n\n  --glow-x: 50%;\n  --glow-y: 50%;\n  --glow-intensity: 0;\n  --glow-radius: 200px;\n}\n\n.services__grid--magic .magic-bento-card:hover {\n  transform: translateY(-2px);\n}\n\n.services__grid--magic .magic-bento-card__header,\n.services__grid--magic .magic-bento-card__content {\n  display: flex;\n  position: relative;\n  color: var(--magic-white);\n}\n\n.services__grid--magic .magic-bento-card__header {\n  gap: 0.75em;\n  justify-content: space-between;\n}\n\n.services__grid--magic .magic-bento-card__content {\n  flex-direction: column;\n}\n\n.services__grid--magic .magic-bento-card__label {\n  font-size: 16px;\n}\n\n.services__grid--magic .magic-bento-card__title,\n.services__grid--magic .magic-bento-card__description {\n  --clamp-title: 1;\n  --clamp-desc: 2;\n}\n\n.services__grid--magic .magic-bento-card__title {\n  font-weight: 400;\n  font-size: 16px;\n  margin: 0 0 0.25em;\n}\n\n.services__grid--magic .magic-bento-card__description {\n  font-size: 12px;\n  line-height: 1.2;\n  opacity: 0.9;\n}\n\n.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__title,\n.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__description {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__title {\n  -webkit-line-clamp: var(--clamp-title);\n  line-clamp: var(--clamp-title);\n}\n\n.services__grid--magic .magic-bento-card--text-autohide .magic-bento-card__description {\n  -webkit-line-clamp: var(--clamp-desc);\n  line-clamp: var(--clamp-desc);\n}\n\n.services__grid--magic .magic-bento-card__border-glow {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 6px;\n  background: radial-gradient(\n    var(--glow-radius) circle at var(--glow-x) var(--glow-y),\n    rgba(var(--magic-glow-rgb), calc(var(--glow-intensity) * 0.8)) 0%,\n    rgba(var(--magic-glow-rgb), calc(var(--glow-intensity) * 0.4)) 30%,\n    transparent 60%\n  );\n  border-radius: inherit;\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  mask-composite: exclude;\n  pointer-events: none;\n  z-index: 3;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.services__grid--magic .magic-bento-card--border-glow:hover .magic-bento-card__border-glow {\n  opacity: 1;\n}\n\n.services__grid--magic .magic-bento-card--border-glow:hover {\n  box-shadow:\n    0 4px 20px rgba(46, 24, 78, 0.4),\n    0 0 30px var(--magic-purple-glow);\n}\n\n.services__grid--magic .particle-container {\n  position: relative;\n  overflow: hidden;\n}\n\n.services__grid--magic .particle::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: rgba(var(--magic-glow-rgb), 0.2);\n  border-radius: 50%;\n  z-index: -1;\n}\n\n.services__grid--magic .particle-container:hover {\n  box-shadow:\n    0 4px 20px rgba(46, 24, 78, 0.2),\n    0 0 30px var(--magic-purple-glow);\n}\n\n.global-spotlight {\n  mix-blend-mode: screen;\n  will-change: transform, opacity;\n  z-index: 200 !important;\n  pointer-events: none;\n}\n\n.services__magic-hit {\n  position: absolute;\n  inset: 0;\n  z-index: 12;\n}\n\n.services__grid--magic .services__card-inner {\n  position: relative;\n  z-index: 4;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
